import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {TuiAlertService} from '@taiga-ui/core';
import {RecipientUser} from '@gatewee/types/user';
import {AuthService} from '../../../_services/auth/auth.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
  standalone: false,
})
export class PasswordResetComponent implements OnInit {
  signupForm!: FormGroup;
  hide_show = false;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('token') resetToken!: string;
  user!: RecipientUser;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly alerts: TuiAlertService,
    private readonly translate: TranslateService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.verifyToken();
    this.initializeForm();
  }

  initializeForm() {
    this.signupForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      resetToken: [this.resetToken],
    });
  }

  passwordHide() {
    this.hide_show = !this.hide_show;
  }

  verifyToken() {
    this.authService.verifyResetToken(this.resetToken).subscribe({
      next: (data: RecipientUser) => {
        if (data.email) {
          this.user = data;
        }
      },
      error: () => {
        void this.router.navigate(['/page-error-404']).then(() => {
          this.alerts
            .open(
              this.translate.instant(
                'features.passwordReset.toast.invitationExpired',
              ),
              {
                label: this.translate.instant('common.status.error'),
                appearance: 'error',
              },
            )
            .subscribe();
        });
      },
    });
  }

  onSubmit() {
    if (this.signupForm.invalid) {
      this.alerts
        .open(
          this.translate.instant('features.passwordReset.toast.formError'),
          {
            label: this.translate.instant('common.status.error'),
            appearance: 'error',
          },
        )
        .subscribe();
      return;
    }

    const {password, resetToken} = this.signupForm.value;
    this.authService
      .passwordReset({password, resetToken} as RecipientUser)
      .subscribe({
        next: () => {
          this.alerts
            .open(
              this.translate.instant('features.passwordReset.toast.success'),
              {
                label: this.translate.instant('common.status.success'),
                appearance: 'success',
              },
            )
            .subscribe();
          this.authService.login(this.user.email, password).subscribe(
            () => {
              void this.router.navigate(['/panel']).then(() => {
                this.alerts
                  .open(
                    this.translate.instant(
                      'features.signup.toast.loginSuccess',
                    ),
                    {
                      label: this.translate.instant('common.status.success'),
                      appearance: 'success',
                    },
                  )
                  .subscribe();
              });
            },
            () => {
              this.alerts
                .open(
                  this.translate.instant('features.signup.toast.loginError'),
                  {
                    label: this.translate.instant('common.status.error'),
                    appearance: 'error',
                  },
                )
                .subscribe();
            },
          );
        },
        error: () => {
          this.alerts
            .open(
              this.translate.instant('features.passwordReset.toast.error'),
              {
                label: this.translate.instant('common.status.error'),
                appearance: 'error',
              },
            )
            .subscribe();
        },
      });
  }
}
